// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/prefer-default-export */
export const helmetAccessoryItem = {
	productId: '101',
	itemId: 'dummy-item-id-101',
	name: 'Bluetooth Motorcycle Helmet',
	basePrice: 275.0,
	specs: [],
	imgUrl: 'https://static.sena.com/images/default-source/products/momentum-pro-helmet/sena_carousel_momentuminc-pro-white.png?sfvrsn=a29ebdda_0',
	description: 'Tech-enabled motorcycle helmet',
	oemId: 'generic-manufacturer-id',
};

export const jacketAccessoryItem = {
	productId: '102',
	itemId: 'dummy-item-id-102',
	name: 'Leather Jacket',
	basePrice: 400.0,
	specs: [],
	imgUrl: 'https://www.pngall.com/wp-content/uploads/4/Black-Leather-Jacket-PNG-Download-Image.png',
	description: 'Fancy, cool leather jacket',
	oemId: 'generic-manufacturer-id',
};

export const homeChargerAccessoryItem = {
	productId: '103',
	itemId: 'dummy-item-id-103',
	name: 'Bosch EV Smart Home Charger',
	basePrice: 400.0,
	specs: [],
	imgUrl: 'https://www.boschevsolutions.com/sites/default/files/styles/product_image/public/Power-Max%20PM%20REMOVED.png?itok=BofdvlWl',
	description: 'Level 2 smart home charging station',
	oemId: 'generic-manufacturer-id',
};

export const chargerAdapterAccessoryItem = {
	productId: '104',
	itemId: 'dummy-item-id-104',
	name: 'Charging Adapter',
	basePrice: 60.0,
	specs: [
		{
			name: 'Chord color',
			price: 100,
			description: 'red',
		},
	],
	imgUrl: 'https://ae01.alicdn.com/kf/Hbfaba988565f402aaecfe4ad7bb1d9bfo.png',
	description: 'Portable, level 1 charger - for when you are on the go!',
	oemId: 'generic-manufacturer-id',
};
